// extracted by mini-css-extract-plugin
module.exports = {"Container":"PasswordResetRequest_Container__1G-8-","EmailInput":"PasswordResetRequest_EmailInput__qivJx","Button":"PasswordResetRequest_Button__2Zypa"};